import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { format, formatDistanceToNow } from 'date-fns';
import { SuperAdminOnly } from '@/components/SuperAdminOnly';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { ActionButton } from '@/components/ui+/ActionButton';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/r/$restaurantId/menu/$menuId/versions')({
  component: Component,
});

function Component() {
  const { menuId } = Route.useParams();

  const {
    data: menuVersions,
    isError,
    isPending,
  } = useQuery(api.menuVersions.listByMenuId, {
    menuId,
  });

  if (isPending) {
    return <LoadingIcon />;
  }
  if (isError) return <div>Error</div>;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Menu Versions</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Time</TableHead>
              <TableHead className="text-center hidden md:table-cell">Menu Items</TableHead>
              <TableHead className="text-center hidden md:table-cell">Categories</TableHead>
              <TableHead className="text-center hidden md:table-cell">Mod Groups</TableHead>
              <TableHead className="text-center hidden md:table-cell">Modifiers</TableHead>
              <SuperAdminOnly>
                <TableHead className="hidden md:table-cell" />
              </SuperAdminOnly>
            </TableRow>
          </TableHeader>
          <TableBody>
            {menuVersions.map((mv) => {
              const creationTime = new Date(mv._creationTime);
              return (
                <TableRow key={mv._id}>
                  <TableCell className="py-0">
                    <span className="font-medium">{format(creationTime, 'h:mm a')}</span>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <span className="px-2 text-muted-foreground text-xs">
                          {formatDistanceToNow(creationTime, { addSuffix: true })}
                        </span>
                      </TooltipTrigger>
                      <TooltipContent side="bottom">{mv._creationTime}</TooltipContent>
                    </Tooltip>
                  </TableCell>
                  <TableCell className="py-0 text-center">{mv.menuItems.length}</TableCell>
                  <TableCell className="py-0 text-center">{mv.categories.length}</TableCell>
                  <TableCell className="py-0 text-center">{mv.modifierGroups.length}</TableCell>
                  <TableCell className="py-0 text-center">{mv.modifiers.length}</TableCell>

                  <SuperAdminOnly>
                    <TableCell className="py-0 text-right">
                      <Link
                        params={{ menuVersionId: mv._id }}
                        target="_blank"
                        to={'/menu-versions/$menuVersionId'}
                      >
                        <ActionButton size="sm" variant={'link'}>
                          Compare to latest
                        </ActionButton>
                      </Link>
                    </TableCell>
                  </SuperAdminOnly>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
